import type { Action } from "../../actions/types";

export type StoreState = string;

export const initialState = "";

export function reducer(
  state: StoreState = initialState,
  action: Action
): StoreState {
  switch (action.type) {
    case "EXCHANGE_REDEEM_SUCCESS":
      return "success";
    case "EXCHANGE_REDEEM_FAILURE":
      return "failure";

    case "EXCHANGE_REDEEM_REQUEST":
      return "loading";

    case "SET_EXCHANGE_ID": // Reset status when switching to a new exchange
      return initialState;

    default:
      return state;
  }
}
